module.exports = __webpack_public_path__ + "components/flag/static/square/nu-c95778b635357c7907a9f9f2657f8f23.svg";